var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ filter: true, active: _vm.opened }},[(_vm.opened)?_c('div',{staticClass:"cover",on:{"click":function($event){_vm.opened = false}}}):_vm._e(),_c('div',{staticClass:"title",on:{"click":function($event){_vm.opened = !_vm.opened}}},[_vm._v(_vm._s(_vm.label))]),(_vm.opened)?_c('div',{staticClass:"results"},_vm._l((_vm.sortedTags),function(t){return _c('div',{key:t.value,class:{
        suggestion: true,
        category: t.type === 'category',
        year: _vm.category === 'year',
        verylarge:
          _vm.valueCounts &&
          _vm.valueCounts[t.value] > 1000 * (_vm.category === 'year' ? 5 : 1),
        large:
          !_vm.valueCounts ||
          (_vm.valueCounts &&
            _vm.valueCounts[t.value] > 200 * (_vm.category === 'year' ? 5 : 1)),
        medium:
          _vm.valueCounts &&
          _vm.valueCounts[t.value] > 50 * (_vm.category === 'year' ? 5 : 1),
        small:
          _vm.valueCounts &&
          _vm.valueCounts[t.value] > 10 * (_vm.category === 'year' ? 5 : 1),
        verysmall: _vm.valueCounts
      },on:{"click":function($event){return _vm.addTag(t)}}},[_c('span',[_vm._v(_vm._s(t.value))])])}),0):_vm._e(),(_vm.index >= 0 && _vm.opened && _vm.label !== '')?_c('div',{staticClass:"remove",on:{"click":_vm.removeTag}},[_c('div',[_vm._v("— remove")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }